import React from "react";
import { Link } from "react-router-dom";
import Layout from "../../components/layout";
import UserProfileForm from "../../components/profile/UserProfileForm";
import PasswordChangeForm from "../../components/profile/PasswordChangeForm";
import { useAppSelector } from "../../app/hooks";
import { getLoggingUser } from "../../features/loggingUser/loggingUserSlice";
import { t } from "../../locales";
import { route } from "../../static/route";

const ProfilePage = () => {
  const loggingUser = useAppSelector(getLoggingUser);

  return (
    <Layout>
      <div className="px-6 py-6">
        {/* Breadcrumb */}
        <nav className="text-sm font-semibold text-gray-500 mb-2">
          <Link to={route.dashboard} className="text-brand-dark hover:underline">{t.profile.breadcrumbHome}</Link>
          <span className="mx-2">&rsaquo;</span>
          <span className="text-gray-500">{t.profile.pageTitle}</span>
        </nav>

        {/* Page title */}
        <h1 className="text-2xl font-bold text-brand-dark mb-6">{t.profile.pageTitle}</h1>

        {/* Forms */}
        <div className="flex flex-col gap-6">
          <UserProfileForm loggingUser={loggingUser} />
          <PasswordChangeForm />
        </div>
      </div>
    </Layout>
  );
};

export default ProfilePage;
